export const BUILD_INFO_CONST = {
  time: '2026-11-05T05:25:06.585Z',
  commit: '27268d08',
  branch: 'develop',
  tag: 'unknown',
};
